var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 868.97,
    height: 733.31,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 868.97 733.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.89,
    cy: 391.73,
    rx: 225.31,
    ry: 267.27,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.9,
    cy: 357.1,
    rx: 31.08,
    ry: 13.47,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m492.21,368.91c.6-4.04.26-25.6.01-29.74-35.4-1.82-35.89,31.43-.15,30.04,0-.02.13-.28.14-.3h0Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m433.79,650.68c51.2-15.2,63.32-26.28,84.59-42.41,9.7-7.35,20.04-13.67,32.51-19.77,43.38-21.21,100.65-6.89,146.03-23.44,61.21-22.31,107.75-79.91,116.18-143.78,4.3-32.57-1.74-68.23-24.46-92.15-15.53-16.35-37.24-25.66-59.14-31.55-36.09-9.71-75.12-11.1-110.68.48-55.11,17.94-97,66.23-114.92,120.73-5.09,15.49-8.48,31.56-15.02,46.51-16.36,37.38-51.12,64.91-66.04,102.88-8.11,20.64-9.82,43.67-4.84,65.23,1.22,5.29,2.98,10.73,6.92,14.5s.07,2.94,2.63,4.04l6.24-1.27h0Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    #blink-right_eyelid-top {\n      transform: translateY(10px);\n    }\n    #blink-right_eyelid-bottom {\n      transform: translateY(-10px);\n    }\n    #blink-left_eyelid-top {\n      transform: translateY(10px);\n    }\n    #blink-left_eyelid-bottom {\n      transform: translateY(-10px);\n    }\n    .blink-eyelid-top {\n      animation: blink-up 10s ease-out infinite;\n      animation-delay: 2s;\n    }\n    .blink-eyelid-bottom {\n      animation: blink-down 10s ease-out infinite;\n      animation-delay: 2s;\n    }\n\n    .blink-eyelid.close {\n      transform: translateY(0px);\n    }\n\n    @keyframes blink-up {\n    0% {\n      transform: translateY(10px);\n    }\n    2% {\n      transform: translateY(0);\n    }\n    4% {\n      transform: translateY(10px);\n    }\n    100% {\n      transform: translateY(10px);\n    }\n  }\n\n  @keyframes blink-down {\n    0% {\n      transform: translateY(-10px);\n    }\n    2% {\n      transform: translateY(0);\n    }\n    4% {\n      transform: translateY(-10px);\n    }\n    100% {\n      transform: translateY(-10px);\n    }\n  }\n\n  @keyframes smoke-letter-appear {\n  0% {\n    fill-opacity: 0;\n  stroke-opacity: 0;\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    fill-opacity: 1;\n     stroke-opacity: 1;\n    opacity: 1;\n    transform: translateY(0) translateX(35px);\n  }\n}\n\n.smoke-letter {\n  fill-opacity: 0;\n  stroke-opacity: 0;\n  opacity: 0;\n  transform: translateY(150px);\n  animation: smoke-letter-appear 1s ease-out forwards;\n}\n\n.smoke-letter:nth-child(1) {\n  animation-delay: 1.25s;\n}\n\n.smoke-letter:nth-child(2) {\n  animation-delay: 1s;\n}\n\n.smoke-letter:nth-child(3) {\n  animation-delay: 0.75s;\n}\n\n.smoke-letter:nth-child(4) {\n  animation-delay: 0.5s;\n}\n\n.smoke-letter:nth-child(5) {\n  animation-delay: 0.25s;\n}\n\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "face-and-frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "m569.44,545.63c-7.14-19.69-20.88-36.15-34.36-52.18-14.47-10.83-15.86-36.23-9.88-57.51s18.01-40.32,26.08-60.89c8.07-20.58,11.86-44.74,1.36-64.19-7.76-14.38-22.37-24.33-29.14-39.2-5.64-12.38-5.12-26.56-7.57-39.95-6.95-38.06-34.3-61.51-72.79-65.44-38.49-3.93-84.86,13.44-99.36,49.3-1.39-.34-2.78-.6-4.18-.82-5.4-2.26-11.43-3.27-17.25-2.97-12.8.66-24.74,6.45-35.91,12.76-25.85,14.6-52.14,36.68-53.4,66.35-.69,16.14,6.36,31.62,7.72,47.72,1.48,17.43-3.73,34.66-8.62,51.46s-9.57,34.28-7.01,51.59c1.98,13.38,9.42,26.67,20.62,33.59-3.76,12.84-7.88,25.59-10.44,38.71-4.32,22.18-3.52,46.93,9.99,65.04l.92-10.79c14.66,15.2,11.54,39.96,4.64,59.92-6.9,19.96-16.73,40.61-12.24,61.25,3.52,16.17,15.69,29.51,30.13,37.6,14.44,8.09,31.02,11.51,47.46,13.48,71.2,8.52,146.57-10,201.57-56.01,20.18-16.89,37.68-37.55,47.92-61.79s12.73-52.28,3.76-77.02h-.02,0Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck",
    d: "m450.26,655.83c-12.43-44.38-10.18-52.24-19.21-97.44-4.37-21.88-8.34-44.44-4.21-66.37-15.2-.9-30.3-4.14-44.39-9.92-27.98-11.48-51.63-33.21-65.43-60.13,6.51,25.37,5.52,51.84,4.47,77.77-.49,11.99-1.11,24.49-7.77,37.23l-35.61,110.22c28.95,1.8,54.21,20.27,82.54,26.5,13.55,2.98,27.55,3.1,41.43,3.2,17.53.13,35.05.26,52.58.39-2.88-6.33-2.23-13.69-4.4-21.45h0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "face-background",
    d: "m305.68,369.41c-.12-9.5-11.85-16.24-20.3-11.89s-11.99,15.05-10.81,24.48c1.18,9.43,6.1,17.92,10.92,26.11,2.59,4.41,5.33,8.98,9.62,11.77,4.28,2.79,10.59,3.2,14.13-.5,17.35,21.55,35.19,43.54,58.83,57.9,23.64,14.37,54.64,19.83,78.98,6.7,28.39-15.31,39.57-50.14,44.09-82.08,4.69-33.12,5.02-66.85.98-100.05-37.19,19.45-85.81,14.39-118.21-12.29-.95,18.88-20.7,30.14-37.45,38.91s-34.42,22.39-30.78,40.94h0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-eye"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "iris-right",
    cx: 392.9,
    cy: 357.1,
    rx: 12.43,
    ry: 12.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "iris-right-2",
    cx: 392.9,
    cy: 357.1,
    rx: 7.46,
    ry: 7.21,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "blink-right"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "eye-bgr-right",
    cx: 392.9,
    cy: 357.1,
    rx: 31.08,
    ry: 13.47,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "blink-right_eyelid-top",
    className: "blink-eyelid blink-eyelid-top",
    "data-name": "blink-right eyelid-top",
    x: 360.58,
    y: 356.86,
    width: 65.73,
    height: 13.69,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "blink-right_eyelid-bottom",
    className: "blink-eyelid blink-eyelid-bottom",
    "data-name": "blink-right eyelid-bottom",
    x: 360.58,
    y: 341.8,
    width: 65.73,
    height: 15.06,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye-bgr-right-3",
    cx: 392.9,
    cy: 357.1,
    rx: 31.08,
    ry: 13.47,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "eyebrow-right",
    d: "m354.33,342.24c18.92-14.84,45.81-18.82,68.21-10.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyelashes-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m360.58,356.48c-1.41-2.08-2.81-4.16-4.22-6.25",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.8,349.61c-1.3-1.84-2.26-3.91-2.81-6.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.05,346.17l-2.19-6.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.92,343.83c-.26-1.87-.52-3.75-.78-5.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.63,343.05c.37-2.55.21-5.17-.47-7.65",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.82,341.49c.21-2.13.42-4.27.62-6.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.32,341.8l1.25-7.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.44,342.75l1.88-7.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.1,344.45l3.21-7.06",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.81,346.17l3.59-5.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.76,348.61l3.43-2.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "iris-left",
    d: "m491.96,344.34c-3.68-.6-7.65,1.17-9.66,4.32s-1.95,7.49.14,10.58,6.1,4.76,9.77,4.06c.84-6.35.8-12.81-.26-18.95h.01Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iris-left-2",
    d: "m491.8,348.94c-1.9-.31-3.94.6-4.98,2.23s-1.01,3.86.07,5.45,3.15,2.45,5.04,2.09c.43-3.27.41-6.6-.13-9.77h0Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "blink-left"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "blink-left_eyelid-top",
    "class-": "blink-eyelid blink-eyelid-top",
    "data-name": "blink-left eyelid-top",
    x: 465.6,
    y: 355.73,
    width: 29.7,
    height: 13.69,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "blink-left_eyelid-bottom",
    "class-": "blink-eyelid blink-eyelid-bottom",
    "data-name": "blink-left eyelid-bottom",
    x: 465.6,
    y: 338.24,
    width: 29.7,
    height: 17.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "eye-bgr-left-2",
    d: "m492.21,368.91c.6-4.04.26-25.6.01-29.74-35.4-1.82-35.89,31.43-.15,30.04,0-.02.13-.28.14-.3h0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "eyebrow-left",
    d: "m459.57,331.76c11.54-3.42,23.4-5.74,35.37-6.94",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyelashes-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m494.23,338.71c2.56-1.4,5.13-2.8,7.69-4.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.6,337.28c2.03-2.4,4.05-4.8,6.08-7.21",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.44,337.67c-.14-2.1.29-4.23,1.22-6.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73,339.94c-.11-2.16-.23-4.31-.34-6.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.36,340.93c-1.46-1.52-2.91-3.03-4.37-4.55",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.2,344.5c-.91-1.88-2.29-3.53-3.97-4.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.76,349c-1.33-1.35-2.66-2.7-3.99-4.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    d: "m418.35,409.76c4.15,3.95,10.09,5.22,15.71,6.32,5.98,1.17,12.29,2.33,18.06.35,3.25-1.11,6.12-3.17,9.34-4.35,2.52-.93,5.29-1.34,7.51-2.86s3.64-4.76,2.05-6.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "lips"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lips-bgr",
    d: "m396.58,445.89c11.26-1.3,22.29-4.52,32.48-9.48,1.49-.72,3.03-1.5,4.69-1.5,1.55,0,2.99.69,4.45,1.19,4.57,1.58,9.71,1.44,14.19-.39,1.65-.68,3.31-1.59,5.08-1.47,1.33.09,2.55.75,3.77,1.3,4.53,2.05,9.7,2.64,14.58,1.68-3.63,4.87-7.34,9.83-12.27,13.37-9.11,6.53-21.03,7.36-32.24,7.31-6.37-.03-12.82-.28-18.94-2.06s-11.95-5.24-15.79-9.94h0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "lip-line",
    d: "m416.17,448.86c5.59.2,11.21-.59,16.52-2.31.54-.18,1.09-.36,1.66-.35.74.01,1.42.35,2.12.61,5.58,2.11,11.67-.84,16.89-3.7,1.49,1.61,4.07,2.09,6.03,1.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "shoulder",
    d: "m231.46,632.42c2.55-18.43,7.4-36.54,14.4-53.78,6.24-15.39,14.6-30.56,27.87-40.53,13.28-9.97,32.42-13.56,46.68-5.05,14.38,8.58,20.09,26.31,23.57,42.7,7.8,36.8,10.08,74.76,6.74,112.23-.24,2.72-.59,5.62-2.37,7.68-1.65,1.91-4.21,2.73-6.66,3.3-22.58,5.26-46.6-3.56-64.82-17.9s-31.7-33.71-45.4-48.66h0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear-line",
    d: "m287.19,388.34c-2.24-4.44-2.85-9.68-1.69-14.52.73-3.04,2.87-6.38,5.98-6.19,2.09.13,3.72,1.86,4.78,3.66,2.2,3.75,2.85,8.38,1.77,12.59-.84,3.27-2.68,6.65-1.53,9.83.66,1.83,2.21,3.17,3.51,4.63s2.45,3.34,2.03,5.25",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.58,
    cy: 390.49,
    rx: 227,
    ry: 268.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "chest-hair",
    d: "m422.77,557.83c-1.29,4.17-1.38,8.6-1.31,12.97.32,19.99,4.59,41.49,19.3,55.02,4.9-2.32,9.03-6.23,11.6-11,2.44-4.53,3.46-9.67,4.34-14.74,2.46-14.24,4.01-28.64,4.65-43.07.39-8.78.38-17.88-3.08-25.96-.97-2.26-2.28-4.5-4.34-5.85-1.86-1.21-4.14-1.58-6.36-1.6-7.86-.05-12.92,2.56-14.76,9.8-2.25,8.86-7.36,15.81-10.03,24.43h-.01Z",
    style: {
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "hand-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hand-bgr",
    d: "m638.12,456.29c-4.63-2.36-7.4-7.41-8.3-12.52-.9-5.11-.22-10.36.47-15.5,4.62-2.22,9.73,1.71,13.21,5.47,11.23,12.14,20.86,25.77,28.56,40.4,1.62,3.08,3.19,6.31,3.37,9.78.29,5.43-2.81,10.43-6.07,14.79-11.48,15.33-26.95,28.78-31.72,47.33-1.48,3.89-6.67,7.93-12.27,10.25s-11.68,3.16-17.65,4.21c-27.19,4.76-53.56,14.17-77.61,27.71-.95.53-1.92,1.1-2.57,1.97-.68.91-.94,2.06-1.2,3.16-7.18,30.16-30.16,54.22-40.16,83.56l.46-1.46c-6.08,16.77-12.15,33.53-18.23,50.3-4.14,11.43-9.35,24.03-20.5,28.87-10.04,4.36-22.44.51-29.85-7.55s-10.32-19.5-9.91-30.44,3.82-21.54,7.7-31.78c12.35-32.62,29.75-63.32,51.4-90.66,5.52-10.74,13.72-22.54,22.21-34.12,3.25-4.42,6.82-9.03,11.22-11.06,5.62-13.84,14.17-26.66,25.75-36.11,11.57-9.44,26.29-15.33,39.5-14.91,2.08-.54,3.89-2.02,4.83-3.96-3.65.07-7.54.08-10.6-1.91s-4.54-6.78-1.94-9.34c1.86-1.82,4.78-1.75,7.38-1.93s5.67-1.23,6.2-3.78c.44-2.1-1.13-4.19-.84-6.31.37-2.68,3.48-4.1,6.19-4.1s5.39.89,8.07.6,5.54-2.48,5.07-5.15c-.29-1.64-1.73-2.83-2.37-4.36-1.1-2.65.5-5.82,2.91-7.37s5.42-1.82,8.29-1.85c12.7-.15,25.09,3.55,39.01,7.78h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand-lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m642.46,507.22c1.16-5.22,2.31-10.44,3.47-15.65.56-2.54,1.11-5.27.12-7.67-1.07-2.6-3.68-4.19-6.13-5.57-5.69-3.2-11.44-6.28-17.26-9.25-5.35-2.73-10.93-5.42-16.92-5.82-4.58-.31-9.3.72-13.71-.57s-8.23-6.45-5.85-10.37c2.14-3.53,7.24-3.31,11.32-2.64,7.6,1.23,15.2,2.47,22.8,3.7,6.25,1.01,12.96,2.26,15.66,5.34,1.51,2.24,4.3,3.13,6.65,4.45,1.63.91,3.1,2.08,4.57,3.23,2.75,2.17,5.5,4.34,8.25,6.51,0,0,.41.24.68.42,3.1,2.03,2.73,6.98,2.44,10.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.83,463.8c-2.48,1.67-5.41,2.67-8.39,2.86-2.5.16-5.02-.23-7.52-.13s-5.16.79-6.81,2.68-1.8,5.2.21,6.7c2.16,1.62,5.17.45,7.75-.34,6.39-1.96,13.38-1.12,19.68,1.1,6.31,2.21,12.06,5.73,17.76,9.22,1.34.82,2.74,1.7,3.51,3.07.82,1.45.8,3.22.75,4.89-.24,8.99-.49,17.97-.73,26.96",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.68,479.03c-4.27.52-8.47,1.63-12.44,3.28-1.49.62-3.07,1.45-3.67,2.94-.95,2.38,1.12,4.88,3.29,6.24,5.21,3.27,12.08,3.72,17.68,1.16,1.18-.54,2.36-1.22,3.66-1.25,1.33-.03,2.56.62,3.73,1.25,3.01,1.63,6.07,3.3,8.46,5.74,2.39,2.45,4.06,5.84,3.61,9.24-.4,3.08-2.43,5.69-3.37,8.64-1.57,4.95.31,10.8,4.47,13.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.23,526.23c4.24-3.97,9.63-6.71,15.35-7.78,2.59-.49,5.28-.64,7.84,0,2.22.56,4.25,1.69,6.38,2.54,10.73,4.31,24.09.76,31.26-8.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "hand-outline",
    d: "m567.65,497.77c-14.94-.23-29.65,5.66-41.22,15.1-11.57,9.44-20.13,22.27-25.75,36.11-4.4,2.02-7.98,6.63-11.22,11.06-8.5,11.58-16.69,23.39-22.21,34.12-21.65,27.35-39.05,58.04-51.4,90.66-3.88,10.24-7.29,20.84-7.7,31.78s2.5,22.38,9.91,30.44,19.81,11.91,29.85,7.55c11.15-4.84,16.35-17.44,20.5-28.87,6.08-16.77,12.15-33.53,18.23-50.3l-.46,1.46c10-29.34,32.98-53.41,40.16-83.56.26-1.11.52-2.25,1.2-3.16.65-.87,1.62-1.43,2.57-1.97,24.06-13.53,50.43-22.94,77.61-27.71,5.97-1.05,12.05-1.89,17.65-4.21s10.79-6.36,12.27-10.25c4.77-18.55,20.24-32,31.72-47.33,3.26-4.35,6.36-9.35,6.07-14.79-.19-3.47-1.75-6.71-3.37-9.78-7.7-14.64-17.33-28.26-28.56-40.4-3.48-3.76-8.59-7.69-13.21-5.47-.69,5.15-1.38,10.39-.47,15.5.9,5.11,3.67,10.17,8.3,12.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ciggie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ciggie-bgr",
    d: "m648.74,465.25c21.91-10.03,43.17-21.47,63.44-33.28,3.16-.01,6.3-1.93,7.51-4.85s.22-6.66-2.41-8.4-6.65-1.05-8.36,1.6l-.42-.28c-23.11,12.25-46.22,24.51-69.39,37.38,2.51,4.8,7.65,8.74,9.63,7.83h0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ciggie-tip",
    d: "m709.97,416.45c-1.94,3.04-2.2,7.35.12,10.11,2.32,2.76,7.4,2.88,9.26-.21.86-1.44.93-3.22.78-4.89-.17-1.87-.67-3.88-2.14-5.04s-4.13-.85-4.71.94",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "nails"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m635.65,427.52c-1.52-.52-3.26-.61-4.68.15s-2.33,2.54-1.75,4.04c.22.58.63,1.06,1.02,1.53,3.33,3.95,6.86,8.05,11.66,9.97,1.11.45,2.33.77,3.5.52s2.26-1.19,2.33-2.39c.03-.51-.12-1.02-.3-1.51-2.03-5.78-6.88-10.49-12.71-12.35",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.66,449.7c-1.87,0-3.72-.6-5.58-.38s-3.81,1.78-3.42,3.61c.19.91.92,1.62,1.75,2.03s1.76.56,2.67.71c1.54.25,3.08.49,4.64.51,1.62.02,3.23-.2,4.83-.48,1.45-.25,2.94-.57,4.16-1.38.55-.36,1.08-.92,1.04-1.57-.03-.5-.38-.93-.76-1.26-1.87-1.64-4.58-1.77-7.07-1.82-1.5-.03-3.01-.06-4.51-.09",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.59,464.31c-3.3-.6-6.49,1.77-8.29,4.6-.29.45-.56.95-.52,1.48.08,1.22,1.6,1.74,2.82,1.79,3.61.16,7.27-1.08,10.03-3.42.96-.81,1.88-2.09,1.36-3.23-.4-.88-1.48-1.22-2.45-1.29s-1.98.04-2.87-.36",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.14,479.2c-2.38.62-4.7,1.52-6.87,2.67-1.44.76-2.94,1.79-3.31,3.37-.14.58-.1,1.23.24,1.73.56.81,1.7.95,2.69.9,2.82-.16,5.58-1.28,7.71-3.14.75-.65,1.44-1.43,1.71-2.39s.01-2.12-.82-2.66c-1.28-.84-2.96.14-4.08,1.19",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "frame-patch",
    d: "m546.09,580.35c-41.08,48.59-97.83,78.64-160.51,78.64",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "smoke-letters"
  }, /*#__PURE__*/React.createElement("path", {
    className: "smoke-letter",
    id: "smoke-letter-e2",
    d: "m788.31,428.2c-.33.8-1.18,1.35-2.04,1.32s-1.68-.62-1.97-1.43c-1.22,1.31-2.97,2.12-4.76,2.18s-3.6-.62-4.9-1.84c-1.72,1.69-5.07,1.54-7.12-.29-1.71,2.04-5.35,1.91-6.91-.24-1.92,1.16-4.46,1.23-6.43.17-1.84,1.47-4.57,1.72-7.36.74,1.39,1.86,1.16,4.74-.5,6.36,1.13.69,1.86,2,1.86,3.33s-.74,2.63-1.87,3.32c1.97,2.09,1.9,5.75-.14,7.77,1.13.49,1.34,2.31-.21,3.73,2.76-2.58,7.5-2.64,10.33-.14,2.18-2.62,6.75-2.7,9.02-.15,2.12-2.37,6.3-2.41,8.47-.09,1.88-2.09,5.56-2.15,8.09.07,1.45-1.39,3.71-1.84,5.58-1.12.69.27,1.33.68,2.05.85.82.2,1.68.06,2.52.02s1.75.02,2.42.54.93,1.62.33,2.21c1.21-.46,2.73.28,3.12,1.51s-.43,2.71-1.68,3.03c1.09,1.01,1.26,2.86.38,4.05s-2.7,1.57-3.99.82c-.24,1.28-1.42,2.33-2.72,2.42s-2.61-.79-3.02-2.03c-.59,1.54-2.11,2.67-3.75,2.79s-3.31-.78-4.12-2.21l-.4,1.57c-.21.95-1.08,1.72-2.04,1.81s-1.96-.5-2.34-1.4c-1.62,1.46-4.59.89-5.55-1.07-.83,1.43-2.46,2.36-4.11,2.37s-3.28-.92-4.12-2.35c-.55,1.35-1.94,2.31-3.39,2.35s-2.89-.86-3.5-2.18c-1.46,2.13-5.01,2.34-7.13.66,2.07,1.23,2.52,4.49.86,6.24,1.29.44,2.2,1.79,2.15,3.15s-1.08,2.62-2.4,2.96c1.28.23,2.32,1.44,2.34,2.74s-.96,2.56-2.23,2.84c.91.26,1.62,1.13,1.69,2.08s-.49,1.91-1.36,2.31c1.72.99,1.76,3.92.1,5.48.76-1.68,2.66-2.76,4.49-2.57s3.46,1.65,3.85,3.45c.31-1.17,1.51-2.03,2.72-1.95s2.29,1.08,2.45,2.28c.66-1.25,2.01-2.12,3.43-2.19s2.85.64,3.64,1.82c.27-1.27,1.55-2.24,2.84-2.16s2.45,1.2,2.56,2.49c.44-1.37,1.72-2.44,3.15-2.62s2.93.54,3.7,1.76c.36-1.03,1.43-1.77,2.52-1.75s2.13.81,2.44,1.86c.8-1.3,2.31-2.12,3.84-2.1s3.01.9,3.76,2.23c.35-1.02,1.49-1.7,2.55-1.52s1.92,1.2,1.91,2.28c.77-.25,1.57-.51,2.38-.41s1.62.66,1.72,1.46-.81,1.63-1.53,1.25c1-.44,2.32.15,2.65,1.19s-.39,2.29-1.46,2.52c1.02.66,1.44,2.1.94,3.21s-1.86,1.74-2.78.99c-.13,1.04-.27,2.12-.87,2.98s-1.8,1.4-2.72.9c-.44-.24-.93-.69-1.36-.43-.2.12-.29.37-.39.58-.4.78-1.29,1.29-2.16,1.22s-1.68-.69-1.96-1.53l-1.89-.66c-.19.7-.99,1.16-1.69.97s-1.16-.99-.98-1.69c-.58,1.35-2.02,2.29-3.49,2.26s-2.88-1.01-3.41-2.38c-.74,1.58-2.36,2.72-4.09,2.89s-3.54-.63-4.58-2.04c-1.04,1.51-2.82,2.48-4.65,2.53s-3.66-.82-4.78-2.27c-1.32,1.36-3.26,2.1-5.15,1.94s-3.69-1.19-4.77-2.75c-.86,1.85-2.56,2.85-4.29,2.82s-3.41-1.07-4.19-2.61c-1.57,1.51-3.97,2.2-6.03,1.48s-3.55-2.97-3.14-5.11c-1.16,1.05-3.01,0-3.46-1.52s.27-3.2,1.45-4.25c-2.62-.85-4.35-3.84-3.78-6.54.14-.65.4-1.28.86-1.75s1.14-.76,1.79-.63c-1.76-.55-2.74-2-2.66-3.46s1.2-2.8,2.62-3.13c-1.12.31-2.38-.41-2.83-1.48s-.16-2.37.58-3.26,1.87-1.41,3.02-1.58c-1.57-.5-2.78-1.96-2.97-3.59s.66-3.34,2.07-4.18c-1.44-.55-1.86-1.97-1.52-3.05s1.21-1.91,2.04-2.69c-1.22.04-2.18-1.25-2.16-2.47s.78-2.32,1.66-3.17c-2.2-.07-4.16-2.04-4.22-4.24s1.8-4.27,3.99-4.46c-.52-1.18-1.28-2.27-1.37-3.44s.52-2.35,1.51-2.98c-1.46.19-2.96-.65-3.67-1.93s-.68-2.92-.05-4.24,1.82-2.35,3.17-2.93l.33-1.12c-1.13-.95-1.76-2.46-1.64-3.94s.97-2.87,2.23-3.63c-1.18-1.25-1.64-3.15-1.15-4.8s1.9-2.99,3.57-3.4c.29-1.45,1.3-2.73,2.64-3.35s2.97-.55,4.62.17c.9-1.36,2.47-2.25,4.1-2.31s3.27.69,4.27,1.97c2.33-1.85,5.89-1.93,8.31-.2,2.33-1.98,6.25-1.67,8.24.65,2.23-2.34,6.38-2.45,8.84.27,2.9-2.9,8.07-3.1,11.18-.43,1.63-2.13,5.26-2.28,7.05-.28,1.46-.5,3.01-1,4.52-.69s2.9,1.78,2.55,3.28c1.41.19,2.63,1.34,2.9,2.74s-.45,2.92-1.69,3.61c.31,1.14-.08,2.44-.96,3.23s-2.22,1.02-3.32.59c-.54,1.06-1.6,1.84-2.78,2.04s-2.43-.2-3.28-1.04",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "smoke-letter",
    id: "smoke-letter-c",
    d: "m758.86,380.29c.41-.36,1.1-.13,1.39.33s.26,1.05.16,1.58c-.55,2.93-3.28,5.3-6.26,5.43.32,1.88-.33,3.9-1.69,5.23s-3.39,1.95-5.26,1.59c-1.53,4.61-7.33,7.26-11.82,5.38.31.89-1.32,2.66-3.32,3.15s-4.26-.32-5.5-1.97c-1.15,1.44-3.02,2.28-4.86,2.2s-3.62-1.1-4.64-2.64c-1.87.43-3.43,1.4-4.99,1.21s-2.91-1.8-2.54-3.34c-.34.83-1.26,1.31-2.16,1.39s-1.78-.18-2.65-.43c-.97-.28-1.96-.57-2.77-1.18s-1.41-1.59-1.27-2.59c-1.19,1.19-3.14,1.53-4.66.81s-2.49-2.45-2.32-4.12c-2.06.45-3.46-.42-4.21-1.7s-.81-2.93-.18-4.26c-.37.61-1.27.7-1.91.39s-1.08-.92-1.49-1.51c-.57-.81-1.16-1.65-1.36-2.62s.08-2.11.93-2.63c-1.92.14-3.87-.97-4.73-2.69s-.59-3.95.67-5.4c-2.45-1.24-3.6-2.68-3.76-4.26s.65-3.23,2.01-4.05c-1.36-.61-2.38-1.94-2.62-3.41s.32-3.05,1.42-4.06c-1.57-.71-2.63-2.41-2.6-4.13s1.16-3.37,2.76-4.03c-1.73-.84-2.86-2.79-2.71-4.71s1.56-3.67,3.41-4.23l.29-1.75c-1.34-3.46.57-7.83,4.01-9.21-.63-4.17,2.75-8.52,6.95-8.92.03-3.55,3.36-6.74,7.33-6.17.5-2.21,1.89-4.21,3.79-5.46s4.29-1.72,6.52-1.29c2.42-2.89,7.1-3.56,10.22-.5,1.42-1.28,2.92-2.61,4.78-3.07s4.16.28,4.79,2.09c1.41-1.22,3.38-1.76,5.22-1.44s3.51,1.5,4.42,3.12c1.24-1.3,3.42-1.57,4.94-.63s2.24,3.02,1.57,6.16c1.56-1.69,4.33-2.12,6.33-.97s3.02,3.75,2.34,5.96c1.4-1.03,3.56-.85,4.77.4s1.32,3.41.25,4.78c1.37-.45,3.01.21,3.68,1.49s.27,3.01-.88,3.87c1.55-.28,3.18,1.03,3.25,2.6s-1.46,3.01-3.8,3.37c1.2.82,2.06,2.33,1.69,3.74s-2.29,2.29-3.41,1.36c.23,1.28-1.03,2.59-2.32,2.42s-2.15-1.78-1.59-2.95c-.37.97-1.16,1.8-2.16,2.1s-2.18-.03-2.79-.87-.48-2.17.34-2.79c-.99,1.32-3.2,1.46-4.36.27s-.95-3.39.4-4.35c-.1.07-.2.14-.31.2l-1.1-1.03c-1.84-.28-2.72-2.97-1.41-4.29-1.47.92-3.58.64-4.76-.64s-1.31-3.39-.29-4.8c-3.01,1.81-7.53-.06-8.39-3.46-2.22,1.94-5.85,2.01-8.14.15-2.06,2.3-5.63,3.11-8.48,1.93-1.13,2.95-4.35,4.63-7.04,3.79.26,2.82-2.12,5.62-4.95,5.81.77,2.84-.6,6.12-3.16,7.56,1.5,2.53.85,6.13-1.46,7.97,1.84,2.51.7,6.62-2.72,8.28,1.44.3,2.67,1.45,3.07,2.87s-.07,3.04-1.15,4.04c1.55.4,2.81,1.74,3.13,3.3s-.34,3.29-1.61,4.25c1.65.34,3.06,1.64,3.55,3.25s.03,3.48-1.16,4.67c.88-1.2,2.97-.57,3.64.75s.37,2.91.06,4.36c1.31-.95,3.28-.87,4.5.19s1.59,2.99.84,4.43c1.25-1.48,3.55-1.94,5.28-1.07s2.73,2.99,2.29,4.88c2.45-3.02,7.29-3.75,10.52-1.58.27-1.55,1.53-2.87,3.06-3.23s3.24.27,4.94,1.5c-.64-1.95-.03-4.24,1.48-5.62s3.86-1.75,5.74-.93c-1.1-1.35-1.28-3.37-.45-4.89s2.63-2.46,4.36-2.27c-.66-1.83-.84-3.99.19-5.63s3.59-2.36,5-1.01c.02-1.12.38-2.28,1.16-3.08s2.06-1.17,3.09-.71,1.61,1.82,1.04,3.69c1.95-1.32,4.94-.67,6.16,1.34s.43,4.97-1.64,6.09c.76.84,1.06,2.06.78,3.16s-1.13,2.02-2.19,2.4",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "smoke-letter",
    id: "smoke-letter-r",
    d: "m710,283.14c-.06-.78-.46-1.51-1.05-2.01-.44-.37-.6-.95-.39-1.49.35-.91.26-2-.3-2.81-.39-.56-.98-.95-1.63-1.14-.67-.2-1-.95-.78-1.62.26-.81.24-1.7-.1-2.48-.44-.99-1.4-1.71-2.45-1.95-.65-.15-1-.82-.88-1.47.22-1.19,0-2.48-.64-3.51s-1.7-1.78-2.87-2.1c-.64-.18-1.09-.79-.91-1.43.28-1.03.13-2.18-.46-3.07-.57-.85-1.53-1.41-2.54-1.56-.66-.1-1.12-.7-1.04-1.36.1-.88-.1-1.79-.6-2.52-.58-.84-1.55-1.4-2.56-1.54-.57-.08-1.03-.49-1.1-1.06-.15-1.25-.86-2.43-1.93-3.11-.48-.31-1.03-.5-1.59-.58.25-.07.49-.14.73-.25.83-.38,1.5-1.06,1.91-1.87.29-.59.94-.89,1.57-.69,1.02.34,2.17.31,3.16-.13,1.11-.5,1.98-1.5,2.36-2.66.16-.5.67-.79,1.2-.81,2.23-.07,4.37-1.79,4.91-3.95.12-.49.48-.89.98-.96.87-.13,1.68-.61,2.18-1.34.49-.73.64-1.67.43-2.53-.12-.48,0-.96.36-1.3,1.44-1.38,1.9-3.72,1.11-5.55-.2-.46-.2-1.01.12-1.4.97-1.16.9-3.14-.1-4.27-.41-.46-.46-1.13-.09-1.63.51-.68.92-1.43.96-2.27.04-.71-.35-1.46-.91-1.88-.44-.34-.59-.97-.33-1.47.38-.74.5-1.62.26-2.42-.33-1.09-1.28-1.95-2.38-2.22-.47-.11-.85-.44-.98-.91-.09-.32-.05-.67.13-.95.52-.82.5-1.97-.1-2.75-.35-.45-.86-.74-1.42-.85-.62-.12-1.04-.61-1.08-1.24-.03-.44-.21-.88-.54-1.18-.41-.38-.99-.51-1.54-.42-.58.09-1.13-.3-1.33-.86-.33-.87-.99-1.63-1.85-2-.81-.36-1.76-.37-2.6-.08-.63.22-1.28-.09-1.53-.71-.51-1.26-1.87-2.25-3.27-2.39-1.57-.15-3.1.48-4.43,1.38-.49.33-1.16.25-1.57-.18-1.05-1.07-2.78-1.24-3.98-.53-.51.3-1.18.17-1.55-.29-.59-.73-1.47-1.24-2.41-1.33-1.03-.1-2.08.29-2.83,1.01-.39.37-.98.5-1.44.23-1.33-.76-3.15-.64-4.39.26-.48.35-1.11.3-1.55-.1-.6-.56-1.4-.9-2.23-.9-.78,0-1.54.3-2.12.81-.5.43-1.22.35-1.69-.11-.83-.8-1.97-1.28-3.12-1.27-1.27,0-2.51.63-3.33,1.59-.4.47-1.07.53-1.61.23-2.4-1.38-5.7-1.11-7.83.66-.42.35-1.01.35-1.48.06-1.11-.69-2.51-.76-3.77-.37-1.41.43-2.63,1.41-3.38,2.67-.17.29-.47.49-.8.54-1.43.24-2.73,1.22-3.3,2.56-.65,1.5-.34,3.36.75,4.58l-.73,2.1c-1.29.36-2.23,1.72-2.11,3.05.12,1.34,1.29,2.5,2.63,2.62-1.23.59-2.04,1.97-1.95,3.33.09,1.36,1.07,2.62,2.37,3.05-1.42.54-2.46,1.98-2.52,3.49-.06,1.52.84,3.04,2.21,3.7-1.46.75-2.42,2.38-2.37,4.02s1.1,3.21,2.82,3.88c-1.62.56-2.75,2.28-2.63,3.98s1.5,3.24,3.18,3.56c-1.63.49-2.85,2.1-2.89,3.8-.05,1.7,1.09,3.37,2.69,3.95-1.31.66-2.19,2.1-2.17,3.57s.93,2.89,2.25,3.51c-1.34.64-2.32,1.99-2.51,3.46s.42,3.02,1.56,3.98c-2.35,2.24-2.67,6.3.49,8.72-1.5.43-2.61,1.96-2.54,3.52s1.3,2.99,2.83,3.29c-1.02.32-1.62,1.44-1.63,2.51s.44,2.08.93,3.03c.27.52.61,1.07,1.16,1.24.18.05.38.03.56-.05-.34.82-.4,1.75-.14,2.6.36,1.17,1.31,2.13,3,2.19-.19,1.61,1.37,3.19,2.98,3.01,1.61-.17,2.8-2.05,2.27-3.58.56,1.42,2.63,1.97,3.82,1.01s1.1-3.09-.17-3.95c1.42.7,3.35.02,4.02-1.42.67-1.44-.06-3.35-1.51-3.99,1.41-.12,2.65-1.37,2.76-2.78.11-1.42-.91-2.84-2.29-3.18,1.47-.55,2.54-2.03,2.6-3.6s-.91-3.12-2.33-3.77c1.64-.54,2.86-2.16,2.92-3.89s-1.04-3.43-2.64-4.09c1.87-1.14,1.91-4.32.07-5.51,1.67-.48,2.37-2.92,1.2-4.21l-.2-2.73c.48,1.08,1.64,1.83,2.83,1.81.71,0,1.41-.29,1.95-.75.48-.41,1.18-.42,1.65,0,.88.78,2.18,1.1,3.3.71.54-.19,1.04-.52,1.61-.58,1.34-.14,2.3,1.19,3.42,1.94,1.09.73,2.52.88,3.77.49.79-.24,1.57.35,1.6,1.17.05,1.27.46,2.29,1.19,3.01.65.63,1.53,1,2.43,1.08.74.06,1.24.76,1.1,1.49-.15.8-.05,1.66.32,2.39.48.95,1.4,1.64,2.43,1.9.6.15.97.71.85,1.31-.16.84,0,1.74.46,2.46.45.69,1.17,1.18,1.96,1.39.64.17,1.01.83.87,1.48-.3,1.42.03,2.98.93,4.12.88,1.1,2.25,1.76,3.65,1.83.71.04,1.31.6,1.25,1.31-.2,2.2,1.12,4.56,3.14,5.43.52.22.84.72.82,1.29-.08,2.37,1.68,4.73,3.97,5.33.49.13.88.49.97.99.16.9.78,1.72,1.62,2.08.74.31,1.61.25,2.32-.11.5-.25,1.11-.08,1.49.34.51.56,1.27.9,2.03.83.79-.07,1.5-.57,1.9-1.24.28-.47.83-.75,1.36-.64.87.18,1.83-.06,2.47-.68.72-.7.96-1.83.66-2.78-.13-.41,0-.88.31-1.18.64-.6,1.01-1.5.94-2.38h0Zm-30.96-50.3c-.85-.83-2.19-1.1-3.3-.67s-1.91,1.54-1.97,2.73c-.38-1.26-1.72-2.16-3.04-2.03s-2.46,1.27-2.59,2.58c-.28-1.39-1.61-2.5-3.03-2.51s-2.78,1.06-3.09,2.44c-.45-1.31-1.77-2.28-3.16-2.32s-2.76.84-3.29,2.13c-.69-1.25-2.06-2.1-3.49-2.16s-2.86.68-3.65,1.88c1.77-1.95,1.85-4.95.13-6.09,1.74-1.67,1.49-4.92-.48-6.31.93-.6,1.51-1.71,1.48-2.82-.04-1.11-.69-2.18-1.65-2.72.66-.77,1.34-1.62,1.42-2.63s-.82-2.13-1.8-1.88c1.78-.59,2.42-3.24.95-4.52,1.46.46,3,.7,4.53.68,1.15,0,2.56-.37,2.83-1.49,2.37,1.32,5.55,1.01,7.61-.76.79,1.46,2.65,2.06,4.3,1.86s3.14-1.04,4.81-.81c.72,1.02,1.95,1.67,3.2,1.68,1.25.02,2.49-.6,3.24-1.6-.09,2.66,2.83,4.69,5.22,3.84-1.23.87-1.72,2.65-1.1,4.03s2.28,2.19,3.75,1.85c-1.22.73-1.93,2.21-1.75,3.61.18,1.41,1.26,2.65,2.62,3.05-1.37.02-2.7.86-3.32,2.08s-.5,2.79.29,3.91c-2.23-1.11-5.32.51-5.67,2.98h0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "smoke-letter",
    id: "smoke-letter-a",
    d: "m643.82,160.32c.9-2.66-.33-5.87-2.77-7.25.39-4.09-1.15-7.65-3.88-9.78,1.88-3.81.06-9-3.79-10.81,2.16-4.14.72-9.8-3.15-12.42,1.05-4.37-1.47-9.31-5.62-11.03,1.12-2.83.14-6.28-2.26-8.01,1.92-3.12.12-7.84-3.38-8.9.69-3.19-.9-6.74-3.74-8.35.91-1.83.45-4.23-1.07-5.59s-3.96-1.55-5.68-.45c.7-.28.93-1.51.45-2.3s-1.42-1.18-2.33-1.32c-2.3-.38-4.77.54-6.28,2.32-2.04-.54-4.32-.03-5.93,1.33s-2.5,3.52-2.32,5.62c-1.95.26-3.74,1.56-4.58,3.34s-.73,3.98.3,5.66c-3.47.87-5.28,5.6-3.28,8.57-3.52.93-5.6,5.38-4.06,8.67-3.84,1.55-6,6.35-4.64,10.25l.56,1.01c-2.12.2-4.11,1.55-5.06,3.46-.96,1.91-.86,4.3.24,6.13-1.84.43-3.4,1.91-3.92,3.72-.52,1.82.02,3.9,1.36,5.23-3.5,1.21-5.53,5.56-4.21,9.02-1.8.11-3.49,1.3-4.2,2.96s-.39,3.7.78,5.07c-1.64.31-3.05,1.58-3.54,3.17s-.03,3.44,1.15,4.61c-1.71.7-2.65,2.85-2,4.58s2.78,2.73,4.52,2.13l1.41,1.74c1.2,1.27,3.01,1.94,4.75,1.76,1.74-.18,3.37-1.21,4.28-2.7,1.72.18,3.52-.69,4.44-2.16s.92-3.46.01-4.94c2.48-.92,3.54-4.44,1.97-6.58,2.71-1.07,4.7-3.79,4.88-6.7-.34-.11-.68-.21-1.02-.32l.27-1.76c2.63,1.97,6.7,1.65,8.99-.7,2.13,1.89,5.7,1.83,7.78-.12,2.33,1.62,5.67,1.63,8.01.03,2,1.77,5.48,1.44,7.12-.67,1.97,1.86,5.19,2.24,7.53.88l.88,1.03c-.91.37-1.54,1.36-1.47,2.34s.81,1.88,1.77,2.13c-.89,1.22-1.03,2.95-.35,4.3.68,1.35,2.16,2.26,3.67,2.27-1.06,1.31-1.25,3.26-.45,4.74.8,1.48,2.54,2.4,4.21,2.23-.62,1.63-.08,3.63,1.29,4.7s3.43,1.15,4.86.17c-.49.61-.09,1.58.58,1.97s1.5.34,2.28.28c1-.09,2.05-.22,2.88-.8.82-.58,1.32-1.75.82-2.63,1.92-1.06,3.26-3.12,3.44-5.31s-.8-4.44-2.52-5.8l.02-.02h0Zm-30.99-25.05c-.98-1.32-2.62-2.12-4.26-2.09s-3.25.88-4.19,2.23c.01-.37.03-.74.04-1.11-1.99-1.34-5.02-.74-6.34,1.26-1.09-1.73-3.02-2.91-5.06-3.09-1.51-.13-3.05.29-4.31,1.13-.35.4-.74.76-1.21,1.04.36-.4.77-.74,1.21-1.04,1.54-1.76,1.81-4.45.51-6.31,2.31-1.47,3.05-4.94,1.54-7.23,2.71-.61,4.1-4.36,2.43-6.58,2.74-.75,3.93-4.72,2.05-6.85,2.69-.22,4.37-3.87,2.77-6.05,1.8.18,3.45-1.25,4.06-3.11-.22-.81-.19-1.69.14-2.47.19.84.11,1.69-.14,2.47.15.57.42,1.1.81,1.54.95,1.07,2.53,1.53,3.9,1.14-1.12.89-1.69,2.42-1.42,3.83s1.36,2.62,2.73,3.04c-1.02.98-1.39,2.57-.92,3.91.47,1.33,1.76,2.34,3.17,2.47-1.21.9-1.65,2.7-.98,4.06s2.36,2.11,3.81,1.7c-1.22.85-1.89,2.42-1.66,3.89.23,1.47,1.34,2.76,2.75,3.21-1.29,1.91.41,4.98,2.71,4.89-1.24,1.01-.89,3.33.59,3.93-1.17-.76-3.34-.88-4.72.2h-.01Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "smoke-letter",
    id: "smoke-letter-e1",
    d: "m545.83,35.28c-.33.8-1.18,1.35-2.04,1.32s-1.68-.62-1.97-1.43c-1.22,1.31-2.97,2.12-4.76,2.18s-3.6-.62-4.9-1.84c-1.72,1.69-5.07,1.54-7.12-.29-1.71,2.04-5.35,1.91-6.91-.24-1.92,1.16-4.46,1.23-6.43.17-1.84,1.47-4.57,1.72-7.36.74,1.39,1.86,1.16,4.74-.5,6.36,1.13.69,1.86,2,1.86,3.33s-.74,2.63-1.87,3.32c1.97,2.09,1.9,5.75-.14,7.77,1.13.49,1.34,2.31-.21,3.73,2.76-2.58,7.5-2.64,10.33-.14,2.18-2.62,6.75-2.7,9.02-.15,2.12-2.37,6.3-2.41,8.47-.09,1.88-2.09,5.56-2.15,8.09.07,1.45-1.39,3.71-1.84,5.58-1.12.69.27,1.33.68,2.05.85.82.2,1.68.06,2.52.02s1.75.02,2.42.54.93,1.62.33,2.21c1.21-.46,2.73.28,3.12,1.51.39,1.23-.43,2.71-1.68,3.03,1.09,1.01,1.26,2.86.38,4.05s-2.7,1.57-3.99.82c-.24,1.28-1.42,2.33-2.72,2.42s-2.61-.79-3.02-2.03c-.59,1.54-2.11,2.67-3.75,2.79s-3.31-.78-4.12-2.21l-.4,1.57c-.21.95-1.08,1.72-2.04,1.81s-1.96-.5-2.34-1.4c-1.62,1.46-4.59.89-5.55-1.07-.83,1.43-2.46,2.36-4.11,2.37s-3.28-.92-4.12-2.35c-.55,1.35-1.94,2.31-3.39,2.35s-2.89-.86-3.5-2.18c-1.46,2.13-5.01,2.34-7.13.66,2.07,1.23,2.52,4.49.86,6.24,1.29.44,2.2,1.79,2.15,3.15s-1.08,2.62-2.4,2.96c1.28.23,2.32,1.44,2.34,2.74s-.96,2.56-2.23,2.84c.91.26,1.62,1.13,1.69,2.08s-.49,1.91-1.36,2.31c1.72.99,1.76,3.92.1,5.48.76-1.68,2.66-2.76,4.49-2.57s3.46,1.65,3.85,3.45c.31-1.17,1.51-2.03,2.72-1.95s2.29,1.08,2.45,2.28c.66-1.25,2.01-2.12,3.43-2.19s2.85.64,3.64,1.82c.27-1.27,1.55-2.24,2.84-2.16s2.45,1.2,2.56,2.49c.44-1.37,1.72-2.44,3.15-2.62s2.93.54,3.7,1.76c.36-1.03,1.43-1.77,2.52-1.75s2.13.81,2.44,1.86c.8-1.3,2.31-2.12,3.84-2.1s3.01.9,3.76,2.23c.35-1.02,1.49-1.7,2.55-1.52s1.92,1.2,1.91,2.28c.77-.25,1.57-.51,2.38-.41s1.62.66,1.72,1.46-.81,1.63-1.53,1.25c1-.44,2.32.15,2.65,1.19s-.39,2.29-1.46,2.52c1.02.66,1.44,2.1.94,3.21s-1.86,1.74-2.78.99c-.13,1.04-.27,2.12-.87,2.98s-1.8,1.4-2.72.9c-.44-.24-.93-.69-1.36-.43-.2.12-.29.37-.39.58-.4.78-1.29,1.29-2.16,1.22s-1.68-.69-1.96-1.53l-1.89-.66c-.19.7-.99,1.16-1.69.97s-1.16-.99-.98-1.69c-.58,1.35-2.02,2.29-3.49,2.26s-2.88-1.01-3.41-2.38c-.74,1.58-2.36,2.72-4.09,2.89s-3.54-.63-4.58-2.04c-1.04,1.51-2.82,2.48-4.65,2.53s-3.66-.82-4.78-2.27c-1.32,1.36-3.26,2.1-5.15,1.94s-3.69-1.19-4.77-2.75c-.86,1.85-2.56,2.85-4.29,2.82s-3.41-1.07-4.19-2.61c-1.57,1.51-3.97,2.2-6.03,1.48s-3.55-2.97-3.14-5.11c-1.16,1.05-3.01,0-3.46-1.52s.27-3.2,1.45-4.25c-2.62-.85-4.35-3.84-3.78-6.54.14-.65.4-1.28.86-1.75s1.14-.76,1.79-.63c-1.76-.55-2.74-2-2.66-3.46s1.2-2.8,2.62-3.13c-1.12.31-2.38-.41-2.83-1.48s-.16-2.37.58-3.26,1.87-1.41,3.02-1.58c-1.57-.5-2.78-1.96-2.97-3.59s.66-3.34,2.07-4.18c-1.44-.55-1.86-1.97-1.52-3.05s1.21-1.91,2.04-2.69c-1.22.04-2.18-1.25-2.16-2.47s.78-2.32,1.66-3.17c-2.2-.07-4.16-2.04-4.22-4.24s1.8-4.27,3.99-4.46c-.52-1.18-1.28-2.27-1.37-3.44s.52-2.35,1.51-2.98c-1.46.19-2.96-.65-3.67-1.93s-.68-2.92-.05-4.24,1.82-2.35,3.17-2.93l.33-1.12c-1.13-.95-1.76-2.46-1.64-3.94s.97-2.87,2.23-3.63c-1.18-1.25-1.64-3.15-1.15-4.8s1.9-2.99,3.57-3.4c.29-1.45,1.3-2.73,2.64-3.35s2.97-.55,4.62.17c.9-1.36,2.47-2.25,4.1-2.31s3.27.69,4.27,1.97c2.33-1.85,5.89-1.93,8.31-.2,2.33-1.98,6.25-1.67,8.24.65,2.23-2.34,6.38-2.45,8.84.27,2.9-2.9,8.07-3.1,11.18-.43,1.63-2.13,5.26-2.28,7.05-.28,1.46-.5,3.01-1,4.52-.69s2.9,1.78,2.55,3.28c1.41.19,2.63,1.34,2.9,2.74s-.45,2.92-1.69,3.61c.31,1.14-.08,2.44-.96,3.23s-2.22,1.02-3.32.59c-.54,1.06-1.6,1.84-2.78,2.04s-2.43-.2-3.28-1.04",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "smoke-letter",
    id: "smoke-letter-p",
    d: "m464.43,47.73c1.02-.08,1.86-1.11,1.73-2.13-.11-.87-.93-1.57-1.79-1.64.64-.11,1.21-.6,1.36-1.23.18-.77-.75-1.4-1.49-1.67,2.3-1.75,1.72-5.56-.68-7.18,1.26-2-.13-5.08-2.46-5.46.58-.9.6-2.13.06-3.05s-1.63-1.5-2.7-1.43c.65-1.09.41-2.62-.54-3.46s-2.5-.89-3.5-.12c.44-.81.13-1.94-.66-2.41s-1.94-.19-2.43.59c.13-1.03-.6-2.09-1.6-2.35s-2.15.31-2.54,1.27c-.78-1.77-1.8-2.64-2.95-2.78s-2.35.45-2.94,1.44c-.37-.98-1.37-1.7-2.42-1.73-1.05-.04-2.1.61-2.54,1.56-.55-1.34-1.98-2.27-3.42-2.24-1.45.03-2.83,1.01-3.34,2.37-.44-1.15-1.64-1.96-2.87-1.95-1.23.01-2.41.85-2.83,2-.54-1.67-2.32-2.85-4.07-2.68s-3.28,1.65-3.5,3.4c-.91-1.77-2.1-2.65-3.36-2.67-1.26-.02-2.49.82-2.93,2-.54-1.28-1.98-2.12-3.36-1.96-1.38.16-2.58,1.32-2.8,2.69-.86-.38-1.91-.4-2.9-.13-.99.28-1.93.91-2.36,1.85s-.22,2.19.62,2.78c-1.28.03-2.49.94-2.88,2.16s.06,2.66,1.08,3.43l1.18.36c-1-.28-2.02,1.01-1.52,1.92.08.14.18.24.3.33-.17.19-.32.4-.44.61-.5.91-.8,2.09-.22,2.96.15.22.36.38.61.47-.68.62-1.09,1.55-.94,2.47.26,1.57,2.08,2.67,3.59,2.17-.87.28-1.77.58-2.47,1.17-.7.59-1.15,1.57-.87,2.44.29.87,1.5,1.37,2.19.77-1.52.93-2.41,2.77-2.21,4.53.17,1.46,1.09,2.79,2.36,3.52-.67-.1-1.44.19-1.86.74-.62.81-.63,1.96-.28,2.92s1.01,1.77,1.66,2.56c-1.95-.02-3.67,1.28-3.66,2.83.01,1.25,1.16,2.3,2.37,2.41-1.42.33-2.59,1.75-2.44,3.23.14,1.33,1.32,2.4,2.62,2.63-.97.31-1.8,1.12-1.97,2.14-.25,1.45.89,2.99,2.35,3.18-1.62.38-3.07,1.9-2.86,3.55.11.87.82,1.57,1.63,1.86-.49.35-.87.85-.97,1.45-.22,1.32.93,2.7,2.27,2.72-1.47-.03-2.85,1.21-2.98,2.67s1.01,2.92,2.46,3.15c-1.25.35-2.17,1.62-2.12,2.91s1.07,2.49,2.34,2.74c-1.32.49-2.18,1.77-2,2.98s1.35,2.21,2.58,2.17c-1.04.61-1.4,2.16-.72,3.17s2.24,1.27,3.2.53c-.25.24-.49.48-.74.72.04,1.05.76,2.04,1.74,2.42.98.38,2.18.11,2.91-.64.25.94,1.21,1.63,2.18,1.57s1.84-.87,1.96-1.83c.71.67,1.88.78,2.7.25s1.2-1.65.87-2.57c1.01.14,2.07-.39,2.57-1.27s.38-2.07-.27-2.86c1.79-.45,2.13-3.41.49-4.25,2.02-1.3,1.84-4.85-.3-5.94,1.76-1.04,1.8-4.01.07-5.1,1.64-1.1,1.51-3.97-.22-4.92,1.84-.73,1.89-3.87.08-4.66,1.6-.5,1.82-3.16.32-3.91.24-.25.47-.49.71-.74,1.36,1.74,4.28,1.83,5.53.17,1.24,1.95,4.57,2,5.87.08.44,1.03,1.55,1.74,2.67,1.71,1.12-.03,2.18-.81,2.56-1.87,2.08,1.65,5.44,1.35,7.2-.64,1.44,1.78,4.85,1.06,5.45-1.15,1.72,1.68,5.15.7,5.72-1.64,2.51,1.07,5.77-1.08,5.78-3.81,1.13.5,2.58.18,3.39-.76.81-.94.93-2.41.27-3.46,1.29.11,2.62-.56,3.3-1.67.68-1.1.69-2.59.02-3.7,1.1-.19,2.03-1.11,2.24-2.2s-.32-2.29-1.26-2.87h.02Zm-17.67-3.5c-1.16.12-2.19,1.03-2.45,2.17s.3,2.41,1.3,3c-2.3-.41-4.63,1.97-4.18,4.26-1.93-1.01-4.67.33-5.06,2.48-.94-1.94-4.28-1.89-5.17.07-1.31-1.89-4.73-1.56-5.66.55-.32-.97-1.3-1.69-2.33-1.7-1.03,0-2.02.67-2.37,1.64-.34-.97-1.33-1.68-2.36-1.69-1.03,0-2.03.69-2.38,1.65.96-1.84.76-4.61-.93-5.74,1.1-.56,1.79-1.85,1.62-3.08-.16-1.23-1.16-2.3-2.38-2.54,1.06-.26,1.88-1.28,1.92-2.36.04-1.09-.71-2.16-1.74-2.5,1.1-.25,1.94-1.37,1.87-2.5s-1.04-2.13-2.17-2.24c1.15-.28,2.04-1.38,2.09-2.56.04-1.03-.57-2.05-1.47-2.54,1,.25,2.85-.33,3.34-1.71-.61.92.62,2.17,1.71,1.97s1.82-1.21,2.35-2.18c-.1.38-.2.76-.3,1.13,1.68,1.43,4.7.64,5.47-1.43-.39,1.24,1.01,2.46,2.3,2.36,1.29-.1,2.34-1.07,3.13-2.1-.07,1.31.92,2.61,2.21,2.87,1.05.22,2.19-.28,2.82-1.15.05-.23.16-.45.34-.62-.08.22-.2.43-.34.62-.15.75.35,1.67,1.11,2,.99.43,2.13.17,3.18-.11-.34.71-.24,2.11.58,2.8.71.6,1.85.59,2.58.03-.62.69-.87,1.72-.6,2.62.32,1.04,1.32,1.83,2.4,1.9-1.07.12-1.99,1.07-2.08,2.14-.1,1.07.64,2.16,1.67,2.48h-.02,0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bill-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bill-cloud_bgr",
    "data-name": "bill-cloud bgr",
    d: "m381.99,34.28c-.42-6.59-5.98-11.73-12.39-12.79s-13.33,2.02-16.83,7.5c-9.95-14.76-32.37-15.64-43.22-3.24-5.51-7.76-15.01-12.52-24.52-12.3s-18.78,5.41-23.93,13.41c-10.34-14.88-32.44-12.87-41.52.68-10.96-14.32-34.09-17.2-48.23-6.01-14.07-10.52-35.23-10.24-49.02.64-19.58-10.59-46.95-2.78-58,16.54-11.46.3-22.34,8.22-26.15,19.03-3.81,10.81-.3,23.8,8.43,31.22-8.1,3.4-15.78,8.54-20.41,16-4.64,7.46-5.69,17.53-1.05,24.99s15.56,10.84,22.85,5.94c-7.2,5.33-8.97,16.68-3.73,23.95s16.57,9.17,23.9,4.02l-.21.14c-.11,8.11,6.24,15.83,14.22,17.29s16.65-3.5,19.43-11.12c8.58,12.13,29.51,12.15,38.1.03,3.3,7.81,11.31,13.41,19.79,13.82s16.99-4.38,21.03-11.84c9.77,15.2,36.02,14.87,44.23,2.44,12.79,14.7,39,14.34,51.34-.96,10.16,9.95,28.45,9.77,37.85-.2,10.36,12.62,32.69,12.26,41.35-.46,9.55,7.09,25.69.41,27.65-9.99,12.97-1.24,22.35-16.74,18.12-28.42,14.26-2.65,22-22.23,13.67-33.96,8.64-10.92,3.73-29.6-9.61-34.44-.25-13.4-9.91-26.1-23.14-31.92Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "bill-cloud_script",
    className: "animate-svg force",
    "data-name": "bill-cloud script"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.24,93.48c8.19-2.42,15.66-7.42,21.15-14.16-4.38,14.03-8.76,28.06-13.13,42.08-3.48,11.16-8.86,24.13-20,26.21-6.7,1.25-13.69-2.28-17.98-7.76s-6.19-12.61-6.72-19.65c-1.13-15.18,3.85-30.61,12.94-42.59,9.09-11.97,22.09-20.52,36.2-24.8,10.88-3.29,24.45-3.29,31.48,5.92,5.95,7.79,4.55,19.79-1.37,27.6-5.92,7.82-15.36,11.99-24.78,13.85,6.54-4.7,13.77-8.37,21.36-10.85,2.92-.95,6.38-1.64,8.8.3,1.56,1.25,2.27,3.3,2.78,5.28,3.41,13.45,0,28.55-8.8,39.04-8.81,10.49-22.78,16.07-36.11,14.42-2.71-.34-5.46-.98-7.72-2.57-6.49-4.55-6.36-14.31-5.53-22.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.78,150.03c10.9-9.24,19.86-20.91,26.09-33.99-3.84,9.11-7.78,18.95-5.93,28.71.36,1.88,1.42,4.12,3.27,4.03.84-.04,1.57-.57,2.21-1.14,1.59-1.39,2.93-3.08,3.96-4.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.52,145.69c18.38-24.07,35.08-49.52,49.92-76.08.95-1.7,1.91-3.48,1.99-5.44s-1.04-4.11-2.9-4.47c-1.19-.23-2.38.3-3.43.93-6.79,4.03-10.44,11.87-13.69,19.24-8.79,19.92-17.68,40.17-20.89,61.82-.27,1.85-.46,3.9.57,5.43,2.28,3.37,7.38,1,10.37-1.72,20.3-18.44,34.34-42.98,48.04-67.09,2.49-4.38,5.04-8.98,5.3-14.05.14-2.81-1.29-6.37-4-6.16-1.06.08-1.98.76-2.79,1.46-6.42,5.53-9.93,13.78-13.23,21.72-7.21,17.36-14.46,34.88-18.04,53.41-.53,2.75-.97,5.63-.17,8.31.81,2.67,3.24,5.03,5.93,4.73,1.66-.18,3.07-1.3,4.3-2.46,3.89-3.67,6.94-8.29,8.84-13.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "script-bill-dot-2",
    "data-name": "script-bill-dot",
    d: "m182.94,98.65c4.04-.84,7.82-2.9,10.7-5.86.73-.75,1.46-1.73,1.25-2.76-.4-2.02-3.62-1.69-4.96-.12-1.77,2.07-1.98,5.31-.51,7.6s4.51,3.43,7.13,2.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.48,70.05c1.34,7.92-6.07,16.08-14.08,15.51s-12.12-7.96-11.74-17.36c.3-7.73,6.66-14.33,13.08-18.68s15.67-4.5,22.61-1.07,10.8,10.6,8.21,18.24c-8.71,25.68-17.4,51.39-26.11,77.07-1.21,3.53.82,7.82,4.3,9.17s7.98-.43,9.35-3.91c13.35-34.3,14.44-41.06,28.89-78.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.44,145.41c-1.39,3.84.75,6.1,3.46,7.42s6.1.14,8.23-2,3.28-5.03,4.37-7.85c9.64-24.89,17.61-48.66,27.25-73.54,1.71-3.96,5.5-7.03,9.78-7.55s8.85,1.73,10.78,5.57.93,9.05-2.52,11.62-8.96,2-11.56-1.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "script-bill-dot",
    d: "m328.95,154.16c4.04-.84,7.82-2.9,10.7-5.86.73-.75,1.46-1.73,1.25-2.76-.4-2.02-3.62-1.69-4.96-.12-1.77,2.07-1.98,5.31-.51,7.6s4.51,3.43,7.13,2.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.97,212.26c-5.3-1.41-11.41,2.14-12.81,7.45-1.4,5.31,2.17,11.41,7.48,12.79-1.2,5.34,2.32,11.3,7.57,12.83s11.42-1.62,13.27-6.77c1.14,5.15,3.57,10.5,8.3,12.83s11.84-.35,12.11-5.62c-2.68,8.46,6.01,17.46,14.88,17.24,8.87-.22,16.4-7.28,19.91-15.43.43,4.67,4.75,8.66,9.44,8.72s9.11-3.82,9.65-8.48c5.32,2.02,11.64-4.16,9.74-9.52,3.16,1.47,7.2.81,9.73-1.6,2.53-2.4,3.39-6.4,2.08-9.63.77-4.9-2.44-10.12-7.16-11.64s-10.37.84-12.61,5.26c-.8-5.64-4.47-10.8-9.54-13.4-5.07-2.6-11.4-2.58-16.45.05-1.22-8.12-8.57-14.89-16.76-15.44-8.19-.55-16.38,5.18-18.67,13.06-3.09-6.25-10.75-9.86-17.54-8.25-6.79,1.6-12.02,8.25-11.99,15.23.87-2.4,1.73-4.81,2.6-7.21",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.88,293.53c3.22-4.49-1.3-13.87-7.11-15.49s-12.54,2.52-13.73,8.43c-1.77-4.61-5.79-8.51-10.66-9.29s-10.32,2.13-11.64,6.89,2.56,10.45,7.49,10.3c-4.2-.11-8.56.09-12.3,1.99s-6.71,5.91-6.17,10.07,5.6,7.44,9.23,5.33c-4.23,2.2-6.13,7.78-4.62,12.3s5.96,7.74,10.68,8.35,9.58-1.17,13.23-4.24c.69,5.28,6.24,9.4,11.5,8.53s9.19-6.55,8.15-11.77c4.68,1.94,10.62.09,13.37-4.16,2.75-4.26,2-10.43-1.7-13.9,5.23-5.26,3.96-11.27-5.72-13.33h0Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "type"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.87,709.04c0-6.09,2.1-17.5,7.42-22.82,2.52-2.52,5.39-3.15,7.63-3.15,2.38,0,4.62.77,6.09,1.61l-1.68,8.47c-1.47-1.26-2.59-2.03-3.92-2.03-.98,0-1.82.35-2.59,1.12-3.08,3.08-4.62,12.53-4.62,16.52s1.54,5.04,3.71,5.04c.98,0,2.1-.28,3.57-.84l-1.54,8.12c-1.26.49-2.59.77-3.92.77-6.16,0-10.15-4.2-10.15-12.81Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.61,683.63h8.19l-.98,5.04c1.89-3.64,4.06-5.67,7.14-5.46l-1.89,9.94h-.14c-3.92,0-6.37,2.66-7.42,7.98l-3.92,20.02h-8.26l7.28-37.52Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.1,706.24c-.07.98-.14,1.75-.14,2.24,0,4.34,1.75,5.67,4.69,5.67,1.82,0,3.64-.49,6.65-1.96l-.84,7.63c-2.24,1.33-4.83,2.03-7.21,2.03-6.44,0-11.2-3.99-11.2-13.37,0-4.69,1.61-16.24,7.56-22.19,2.24-2.24,4.9-3.22,7.42-3.22,5.25,0,8.47,4.06,8.47,11.2,0,3.08-.35,5.81-1.61,11.97h-13.79Zm1.12-6.51h6.16c.49-2.31.77-4.27.77-5.81,0-2.24-.7-3.5-1.96-3.5-.49,0-1.05.21-1.54.7-1.47,1.47-2.66,5.04-3.43,8.61Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.76,713.66c0-3.99,1.4-10.5,4.62-13.72,1.61-1.61,3.5-2.31,5.6-2.31,1.96,0,3.78.7,5.39,1.82l.28-1.4c.21-1.05.35-1.96.35-2.8,0-3.15-1.75-4.34-4.62-4.34-1.75,0-3.71.49-6.16,1.47l1.54-7.84c2.31-.84,4.13-1.33,6.65-1.33,6.86,0,10.78,3.78,10.78,10.64,0,1.4-.14,2.87-.7,5.88l-4.2,21.42h-8.26l.7-3.78c-1.82,2.8-4.13,4.34-6.44,4.34-3.22,0-5.53-2.87-5.53-8.05Zm13.3-2.31l1.19-6.23c-.91-.63-1.75-.98-2.66-.98-.56,0-1.12.21-1.61.7-1.75,1.75-2.24,6.09-2.24,7.21,0,2.24.84,2.94,1.96,2.94,1.47,0,2.94-1.26,3.36-3.64Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.41,715.34c0-.7.14-1.89.49-3.85l4.13-21.14h-2.24l1.26-6.72h2.24l1.89-9.59h8.26l-1.89,9.59h4.41l-1.26,6.72h-4.41l-3.57,17.99c-.28,1.4-.7,3.5-.7,4.34,0,1.12.7,1.68,1.96,1.68.63,0,1.12-.07,2.1-.28l-1.33,6.72c-1.19.49-3.01.84-4.69.84-3.64,0-6.65-1.82-6.65-6.3Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.21,683.63h8.26l-7.28,37.52h-8.26l7.28-37.52Zm2.24-11.83h8.4l-1.61,8.26h-8.4l1.61-8.26Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.3,683.63h8.12l-.84,24.36,8.54-24.36h8.12l-14.98,37.66h-8.47l-.49-37.66Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.45,706.24c-.07.98-.14,1.75-.14,2.24,0,4.34,1.75,5.67,4.69,5.67,1.82,0,3.64-.49,6.65-1.96l-.84,7.63c-2.24,1.33-4.83,2.03-7.21,2.03-6.44,0-11.2-3.99-11.2-13.37,0-4.69,1.61-16.24,7.56-22.19,2.24-2.24,4.9-3.22,7.42-3.22,5.25,0,8.47,4.06,8.47,11.2,0,3.08-.35,5.81-1.61,11.97h-13.79Zm1.12-6.51h6.16c.49-2.31.77-4.27.77-5.81,0-2.24-.7-3.5-1.96-3.5-.49,0-1.05.21-1.54.7-1.47,1.47-2.66,5.04-3.43,8.61Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.51,699.87c-1.54,6.02-3.43,9.59-5.32,12.46l2.94,7.14-6.86,2.52-1.47-3.78c-2.31,2.1-4.97,3.64-8.4,3.64-6.79,0-11.06-5.11-11.06-11.9,0-8.12,4.2-12.95,10.29-16.59-1.47-3.43-2.03-6.58-2.03-9.59,0-6.51,3.85-12.32,10.85-12.32,5.95,0,9.66,4.27,9.66,9.87,0,6.65-3.78,11.48-9.87,15.12l2.8,8.47c.63-1.68,1.19-3.92,2.03-7.07l6.44,2.03Zm-13.51,12.11l-3.85-12.11c-3.15,2.17-4.9,5.46-4.9,9.03,0,3.01,1.4,5.53,4.27,5.53,1.61,0,3.08-.84,4.48-2.45Zm0-21.7c3.57-2.45,4.83-5.46,4.83-8.4,0-2.38-.98-3.57-2.59-3.57-2.17,0-3.36,2.45-3.36,5.32,0,1.96.28,4.13,1.12,6.65Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.75,715.34c0-.7.14-1.89.49-3.85l4.13-21.14h-2.24l1.26-6.72h2.24l1.89-9.59h8.26l-1.89,9.59h4.41l-1.26,6.72h-4.41l-3.57,17.99c-.28,1.4-.7,3.5-.7,4.34,0,1.12.7,1.68,1.96,1.68.63,0,1.12-.07,2.1-.28l-1.33,6.72c-1.19.49-3.01.84-4.69.84-3.64,0-6.65-1.82-6.65-6.3Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.72,706.24c-.07.98-.14,1.75-.14,2.24,0,4.34,1.75,5.67,4.69,5.67,1.82,0,3.64-.49,6.65-1.96l-.84,7.63c-2.24,1.33-4.83,2.03-7.21,2.03-6.44,0-11.2-3.99-11.2-13.37,0-4.69,1.61-16.24,7.56-22.19,2.24-2.24,4.9-3.22,7.42-3.22,5.25,0,8.47,4.06,8.47,11.2,0,3.08-.35,5.81-1.61,11.97h-13.79Zm1.12-6.51h6.16c.49-2.31.77-4.27.77-5.81,0-2.24-.7-3.5-1.96-3.5-.49,0-1.05.21-1.54.7-1.47,1.47-2.66,5.04-3.43,8.61Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.06,709.04c0-6.09,2.1-17.5,7.42-22.82,2.52-2.52,5.39-3.15,7.63-3.15,2.38,0,4.62.77,6.09,1.61l-1.68,8.47c-1.47-1.26-2.59-2.03-3.92-2.03-.98,0-1.82.35-2.59,1.12-3.08,3.08-4.62,12.53-4.62,16.52s1.54,5.04,3.71,5.04c.98,0,2.1-.28,3.57-.84l-1.54,8.12c-1.26.49-2.59.77-3.92.77-6.16,0-10.15-4.2-10.15-12.81Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.11,671.8h8.26l-3.15,16.31c2.1-3.08,4.48-5.18,7.35-5.18,3.92,0,5.88,2.8,5.88,6.58,0,1.26-.14,2.31-.42,3.92l-5.39,27.72h-8.26l4.9-25.06c.28-1.54.42-2.31.42-3.15,0-1.61-.77-2.59-2.1-2.59-1.68,0-3.15,1.68-3.64,4.27l-5.18,26.53h-8.26l9.59-49.36Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.08,683.63h8.26l-.84,4.48c2.1-3.08,4.48-5.18,7.35-5.18,3.92,0,5.88,2.8,5.88,6.58,0,1.26-.14,2.31-.42,3.92l-5.39,27.72h-8.26l4.9-25.06c.28-1.54.42-2.31.42-3.15,0-1.61-.77-2.59-2.1-2.59-1.68,0-3.15,1.68-3.64,4.27l-5.18,26.53h-8.26l7.28-37.52Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.42,683.63h8.26l-7.28,37.52h-8.26l7.28-37.52Zm2.24-11.83h8.4l-1.61,8.26h-8.4l1.61-8.26Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.15,709.04c0-6.09,2.1-17.5,7.42-22.82,2.52-2.52,5.39-3.15,7.63-3.15,2.38,0,4.62.77,6.09,1.61l-1.68,8.47c-1.47-1.26-2.59-2.03-3.92-2.03-.98,0-1.82.35-2.59,1.12-3.08,3.08-4.62,12.53-4.62,16.52s1.54,5.04,3.71,5.04c.98,0,2.1-.28,3.57-.84l-1.54,8.12c-1.26.49-2.59.77-3.92.77-6.16,0-10.15-4.2-10.15-12.81Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515.89,713.66c0-3.99,1.4-10.5,4.62-13.72,1.61-1.61,3.5-2.31,5.6-2.31,1.96,0,3.78.7,5.39,1.82l.28-1.4c.21-1.05.35-1.96.35-2.8,0-3.15-1.75-4.34-4.62-4.34-1.75,0-3.71.49-6.16,1.47l1.54-7.84c2.31-.84,4.13-1.33,6.65-1.33,6.86,0,10.78,3.78,10.78,10.64,0,1.4-.14,2.87-.7,5.88l-4.2,21.42h-8.26l.7-3.78c-1.82,2.8-4.13,4.34-6.44,4.34-3.22,0-5.53-2.87-5.53-8.05Zm13.3-2.31l1.19-6.23c-.91-.63-1.75-.98-2.66-.98-.56,0-1.12.21-1.61.7-1.75,1.75-2.24,6.09-2.24,7.21,0,2.24.84,2.94,1.96,2.94,1.47,0,2.94-1.26,3.36-3.64Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.17,671.8h8.26l-9.59,49.36h-8.26l9.59-49.36Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.81,718.84l1.54-7.63c2.8,2.17,4.9,3.22,6.72,3.22,1.96,0,3.22-1.47,3.22-3.5,0-1.54-.7-3.08-3.08-6.72-2.59-3.99-4.13-6.58-4.13-10.57,0-5.88,4.13-10.57,10.71-10.57,3.01,0,5.6.91,7.49,2.17l-1.54,7.63c-2.52-1.75-4.34-2.38-5.67-2.38-1.96,0-3.01,1.33-3.01,3.01,0,1.33.77,2.94,3.15,6.44,2.24,3.29,4.06,6.65,4.06,10.57,0,6.3-4.06,11.34-10.64,11.34-3.43,0-6.79-1.26-8.82-3.01Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.66,706.24c-.07.98-.14,1.75-.14,2.24,0,4.34,1.75,5.67,4.69,5.67,1.82,0,3.64-.49,6.65-1.96l-.84,7.63c-2.24,1.33-4.83,2.03-7.21,2.03-6.44,0-11.2-3.99-11.2-13.37,0-4.69,1.61-16.24,7.56-22.19,2.24-2.24,4.9-3.22,7.42-3.22,5.25,0,8.47,4.06,8.47,11.2,0,3.08-.35,5.81-1.61,11.97h-13.79Zm1.12-6.51h6.16c.49-2.31.77-4.27.77-5.81,0-2.24-.7-3.5-1.96-3.5-.49,0-1.05.21-1.54.7-1.47,1.47-2.66,5.04-3.43,8.61Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623.97,683.63h8.19l-.98,5.04c1.89-3.64,4.06-5.67,7.14-5.46l-1.89,9.94h-.14c-3.92,0-6.37,2.66-7.42,7.98l-3.92,20.02h-8.26l7.28-37.52Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m641.61,683.63h8.12l-.84,24.36,8.54-24.36h8.12l-14.98,37.66h-8.47l-.49-37.66Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m670.38,683.63h8.26l-7.28,37.52h-8.26l7.28-37.52Zm2.24-11.83h8.4l-1.61,8.26h-8.4l1.61-8.26Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.11,709.04c0-6.09,2.1-17.5,7.42-22.82,2.52-2.52,5.39-3.15,7.63-3.15,2.38,0,4.62.77,6.09,1.61l-1.68,8.47c-1.47-1.26-2.59-2.03-3.92-2.03-.98,0-1.82.35-2.59,1.12-3.08,3.08-4.62,12.53-4.62,16.52s1.54,5.04,3.71,5.04c.98,0,2.1-.28,3.57-.84l-1.54,8.12c-1.26.49-2.59.77-3.92.77-6.16,0-10.15-4.2-10.15-12.81Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m709.09,706.24c-.07.98-.14,1.75-.14,2.24,0,4.34,1.75,5.67,4.69,5.67,1.82,0,3.64-.49,6.65-1.96l-.84,7.63c-2.24,1.33-4.83,2.03-7.21,2.03-6.44,0-11.2-3.99-11.2-13.37,0-4.69,1.61-16.24,7.56-22.19,2.24-2.24,4.9-3.22,7.42-3.22,5.25,0,8.47,4.06,8.47,11.2,0,3.08-.35,5.81-1.61,11.97h-13.79Zm1.12-6.51h6.16c.49-2.31.77-4.27.77-5.81,0-2.24-.7-3.5-1.96-3.5-.49,0-1.05.21-1.54.7-1.47,1.47-2.66,5.04-3.43,8.61Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m724.77,718.84l1.54-7.63c2.8,2.17,4.9,3.22,6.72,3.22,1.96,0,3.22-1.47,3.22-3.5,0-1.54-.7-3.08-3.08-6.72-2.59-3.99-4.13-6.58-4.13-10.57,0-5.88,4.13-10.57,10.71-10.57,3.01,0,5.6.91,7.49,2.17l-1.54,7.63c-2.52-1.75-4.34-2.38-5.67-2.38-1.96,0-3.01,1.33-3.01,3.01,0,1.33.77,2.94,3.15,6.44,2.24,3.29,4.06,6.65,4.06,10.57,0,6.3-4.06,11.34-10.64,11.34-3.43,0-6.79-1.26-8.82-3.01Z",
    style: {
      strokeWidth: 0
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroV2);
export default __webpack_public_path__ + "static/media/hero-v2.90ae9eadcaeef981b8a2471abe3cf209.svg";
export { ForwardRef as ReactComponent };